import { Outlet } from 'react-router-dom';
import './styles';
import classes from './style.module.css';

const EmptyLayout = () => (
  <div className={classes.layout}>
    <main>
      <Outlet />
    </main>
  </div>
);

export default EmptyLayout;
